import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { goBack, navStore } from '../app/navigation';
import { handleOverlayBack } from '../ui/backStack';

// Android system Back (pre-TestFlight QA line, 2026-09-16 — Android native-shell QA matrix B).
//
// The app navigates on an in-memory stack (src/app/navigation.ts), not on browser history, so
// without a listener Capacitor's BridgeActivity answers every Back press by finishing the activity:
// one press anywhere inside an inspection would leave the app. The rule here mirrors the on-screen
// affordances exactly — an open overlay closes first, then one screen up the stack (a detour returns
// wholesale, like the on-screen Back), and at a tab root the app goes to the background instead of
// being destroyed, so the inspection state and the session survive an accidental press.
//
// iOS never fires this event and this installer is a no-op there; the QA guard for the shared
// runtime is tests/native/androidBackButton.test.ts.
export function androidBackDecision(state: { stackLength: number; inDetour: boolean }, overlayHandled: boolean): 'overlay' | 'goBack' | 'minimize' {
  if (overlayHandled) return 'overlay';
  if (state.stackLength > 1 || state.inDetour) return 'goBack';
  return 'minimize';
}

export function installAndroidBackButton(): void {
  if (Capacitor.getPlatform() !== 'android') return;
  void App.addListener('backButton', () => {
    const handled = handleOverlayBack();
    const nav = navStore.get();
    const decision = androidBackDecision({ stackLength: nav.stack.length, inDetour: nav.detour !== null }, handled);
    if (decision === 'goBack') goBack();
    else if (decision === 'minimize') void App.minimizeApp();
  });
}
